export default __webpack_public_path__ + "static/media/download (4).3c8bf1c9.svg";